/**
 * PermissionDescription Component
 * Displays the description based on permission state
 */

import React from 'react'
import { Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { PermissionState } from '../../helpers/permissionHelpers'

interface PermissionDescriptionProps {
  permissionState: PermissionState
  hasError: boolean
  errorMessage: string
}

export const PermissionDescription: React.FC<PermissionDescriptionProps> = ({
  permissionState,
  hasError,
  errorMessage
}) => {
  const { t } = useTranslation()
  const isDenied = permissionState === 'denied'

  return (
    <Typography
      sx={{
        color: INTERAX_COLORS.white,
        fontSize: '16px',
        textAlign: 'center',
        maxWidth: '400px'
      }}
    >
      {isDenied
        ? t('gamer.permissionScreen.description.denied')
        : hasError
          ? errorMessage || t('gamer.permissionScreen.description.error')
          : t('gamer.permissionScreen.description.prompt')}
    </Typography>
  )
}
